export const TOOLTIP_POSITION = {
    top: 'above',
    bottom: 'below',
    left: 'left',
    right: 'right',
} as const;
